import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from 'components/SvgIcons/ComplexIcons/blocked-error.svg';
import { Button } from 'components';
import { SUPPORT_EMAIL } from 'config/constants';

export default class BlockedByAdmin extends PureComponent {
  static propTypes = {
    onClose: PropTypes.func,
    options: PropTypes.object,
  };

  render() {
    const { onClose, options: { reason } = {} } = this.props;
    return (
      <div
        className="white-box p-15 text-center flex flex-column align-items-center"
        style={{ maxWidth: '550px' }}
      >
        <ErrorIcon />
        <div className="montserrat fs-16 lh-19 bold mt-6">
          Your account is blocked
        </div>
        <div className="fs-12 lh-20 mt-1">
          {reason} Please, contact administrator{' '}
          <a className="form-link" href={`mailto:${SUPPORT_EMAIL}`}>
            {SUPPORT_EMAIL}
          </a>{' '}
          for more details.
        </div>
        <Button
          onClick={onClose}
          className="_red mt-8"
          style={{ minWidth: '180px' }}
        >
          Close
        </Button>
      </div>
    );
  }
}
